export default __webpack_public_path__ + "static/media/img15.4cafa50a.svg";